
import React, { useEffect, useState } from 'react';
import { getContactDetails } from '../services/logipulse-crm-service';
import "../styles/contactUs.scss";
import { Link } from 'react-router-dom';
import Loader from '../images/transparent-loader.png';
import '../styles/loader.scss';
import DataGrid, {
    Column, Pager,
    Paging,
    SearchPanel, Export,
    FilterRow
} from 'devextreme-react/data-grid';

function ContactUs(props) {
    const [contactUsList, setContactUsList] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const pageSizes = [10, 25, 50, 100];

    useEffect(() => {
        getContactUs();

        return () => {
        };

    }, []);

    const getContactUs = async () => {
        try {
            setLoading(true);
            let response = await getContactDetails();
            const sortArray = response.sort((a, b) => { return new Date(b.Createdate) - new Date(a.Createdate) })

            console.log('ContactUsList++++++++++++', JSON.stringify(sortArray));
            setContactUsList(sortArray);
            setLoading(false);
        } catch (error) {
            console.log('getContactUs error', error);
            setLoading(false);
        }
    }

    const calculateSerialNo = (cellInfo) => {
        return cellInfo.rowIndex + 1;
    }

    return (
        <div className="App">
            <div className="logout_btn">
                <Link to='/ServiceList'>
                    <div className="login_submit_button text-center">Back</div>{' '}
                </Link>
            </div>

            <DataGrid
                dataSource={contactUsList}
                allowColumnResizing={true}
                focusedRowEnabled={true}
                keyExpr="ContactDetailsGuid"
                wordWrapEnabled={true}
                columnResizingMode="widget"
                allowColumnReordering={true}
                showBorders={true}>
                <Paging enabled={false} />
                <Export enabled={true} />
                <FilterRow visible={true} />
                <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                <Paging defaultPageSize={50} />
                <SearchPanel visible={true} highlightCaseSensitive={true} />
                <Column
                    caption="SI NO"
                    cellRender={calculateSerialNo}
                />
                <Column
                    dataField="Name"
                    caption="Name"
                />
                <Column
                    dataField="CompanyName"
                    caption="Company Name"
                />
                <Column
                    dataField="Email"
                    caption="Email"
                />
                <Column
                    dataField="MobileNo"
                    caption="Mobile No"
                />
                <Column
                    dataField="Questions"
                    caption="Questions/Comment"
                />
                <Column
                    dataField="Createdate"
                    caption="Created Date"
                    dataType="datetime"
                />
            </DataGrid>

            {
                isLoading ? (
                    <img src={Loader} alt="" className="loader" />
                ) : null
            }
        </div>
    )
}

export default ContactUs
